var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"content",staticClass:"html-textarea",attrs:{"contenteditable":"true"},on:{"keydown":_vm.onKeyDown,"focus":_vm.onFocus,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }